<template>
  <div class="my">
    <div class="cont">
      <div class="r1"><img @click="goback()" src="static/images/back.svg" alt=""><span>设置新密码</span></div>
      <div class="c2"><span class="c4">手机号码</span><input class="phone" type="text" placeholder="请输入手机号"></div>

      <div class="c3">
        <span class="c4">验证码</span>
        <input class="imgcode" v-model="imgcode" placeholder="请输入图形验证码" style="background-color:transparent;">
        <img class="img_code" id="imgCode" :src="imgUrl" @click="handleClick">
      </div>

      <div class="c3"><span class="c4">短信验证码</span><input class="code"  placeholder="请输入验证码"><span class="c41" :class="{'active': iscl && imgcode}" @click="set()">获取验证码</span></div>
      <div class="me"></div>
      <div class="c6 active" @click="next()">下一步</div>
    </div>
    <div class="cont1">
      <div class="r1"><img src="static/images/back.svg" alt=""><span>找回密码</span></div>
      <div class="q7"><img src="static/images/wjmm.png" alt=""></div>
      <div class="q2"><span class="q4">设置密码</span><input class="pass1" type="password" placeholder="请输入密码"></div>
      <div class="q3"><span class="q4">确认密码</span><input class="pass2" type="password" placeholder="请输入确认密码"></div>
      <div class="me1"></div>
      <div class="q6 active" @click="wanc()">完成</div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Vue from 'vue'
  import {api} from '../global/api';
  export default {
    name: "register",
    data () {
      return {
        zhezhao:false,
        xuan:true,
        iscode:true,
        count:60,
        iscl:false,
        isco:false,
        isMobile:/^1[3578]\d{9}$|^147\d{8}$/,       //手机号码验证规则
        // ispass:/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/, //密码验证 6-10位
        ispass:/^(?=.*?[a-zA-Z])(?=.*?[0-9]).{8,}$/,//必须包含字母、数字，且至少8位
        phone:"",
        code:"",
        sucode:"",
        pass1:"",
        pass2:"",
        ispass1:false,
        ispass2:false,
        imgcode: "",
        imgUrl: '/admin/getImgCode.do'
      }
    },
    methods:{
      handleClick() {
        this.imgUrl = '/admin/getImgCode.do?' + Math.random()
      },
      goback(){
        this.$router.go(-1);
      },
      lo(){
        if($('.lo').hasClass("active")){
          return false;
        }else{
          this.zhezhao=false;
          $('.c51').attr("src","static/images/xz.svg");
        }
      },
      tiaoli(){
        this.zhezhao=true;
      },
      register(){
        this.$router.push({ path: 'register'})
      },
      xz(){
        if(this.xuan){
          $('.c51').attr("src","static/images/wxz.svg");
          this.xuan=false;
        }else{
          $('.c51').attr("src","static/images/xz.svg");
          this.xuan=true;
        }
      },
      set(){
        var _this=this;
        if(this.iscl){
          this.timeDown();
          console.log(this.phone);
          // this.$http.get(api.code+"?phone="+this.phone+"&type=2").then(response  => {
          this.$http.post('/admin/forget/sendCode.do', {
            phone: this.phone,
            code: this.imgcode
          }, {emulateJSON: true}).then(response  => {
            console.log(response);
            if(response.body.success==1){
              _this.isco=true;
              _this.sucode=response.body.others;
            }else{
              $('.me').text(response.body.data);
              this.handleClick()
            }
          })
        }else{
          $('.me').text("请输入正确的手机号");
        }
      },
      // time(){
      //   this.count--;
      //   if(this.count==0){
      //     this.iscl=true;
      //     this.count=60;
      //     $('.c41').text("获取手机验证码")
      //     return false;
      //   }else{
      //     this.iscl=false;
      //     $('.c41').text(this.count+"秒后重新发送")
      //   }
      //   setTimeout(this.time,1000);
      // },
      timeDown() {
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.iscl=false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              $('.c41').text(this.count+"秒后重新发送");
              this.count--;
            } else {
              this.iscl=true;
              $('.c41').text("获取手机验证码");
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      },
      jianting(){
        var _this=this;
        $('.phone').bind('input propertychange', function() {
          _this.phone=$('.phone').val();
          $('.me').text("");
          if(!_this.isMobile.test(_this.phone)){
            _this.iscl=false;
            // if(!$('.c41').hasClass("active")){
            //   $('.c41').addClass("active");
            // }
          }else if(_this.isMobile.test(_this.phone)){
            $('.me').text("");
            _this.iscl=true;
            // $('.c41').removeClass("active");
          }
          console.log(_this.iscl)
        })
        $('.code,.phone').bind('input propertychange', function() {
          _this.code=$('.code').val();
          console.log(_this.code,_this.phone,_this.isco)
          if(_this.code&&_this.phone&&_this.isco){
            $('.lo').css({"cursor":"pointer","background-color":"#c44d41"});
            $('.c6').removeClass("active");
          }else{
            if(!$('.c6').hasClass("active")){
              $('.c6').addClass("active")
            }
          }
        })
        $('.pass1').bind('input propertychange', function() {
          _this.pass1=$('.pass1').val();
          console.log(_this.pass1,_this.ispass.test(_this.pass1));
          if(_this.ispass.test(_this.pass1)){
            _this.ispass1=true;
            $('.me1').text(" ");
          }else{
            _this.ispass1=false;
            // $('.me1').text("密码必须包含一个数字和字母且在6-10位")
            $('.me1').text("密码必须包含字母、数字，且至少8位")
          }
        })
        $('.pass2').bind('input propertychange', function() {
          _this.pass2=$('.pass2').val();
          if(_this.pass2==_this.pass1){
            _this.ispass2=true;
            $('.me1').text("");
          }else{
            _this.ispass2=false;
            $('.me1').text("请输入相同的密码");
          }
          console.log(_this.ispass2,_this.ispass1)
          if(_this.ispass2 && _this.ispass1){
            $('.q6').removeClass("active");
          }else{
            if(!$('.q6').hasClass("active")){
              $('.q6').addClass("active");
            }
          }
        })
      },
      next(){
        if(!$('.c6').hasClass("active")){
          // this.$http.post(api.checkCode, {
          this.$http.post('/admin/front/toNewPass.do', {
            phone: this.phone,
            secretCode:this.code,
            token: this.sucode
          }, {emulateJSON: true}).then(response  => {
            if(response.body.success==1){
              // this.sucode = response.body.others;
              $('.cont').css("display","none");
              $('.cont1').css("display","block");
            }else{
              $('.me').text("验证码错误");
              this.handleClick()
            }
          })
         
          // if(this.code==this.sucode){
          //   $('.cont').css("display","none");
          //   $('.cont1').css("display","block");
          // }else{
          //   $('.me').text("验证码错误")
          // }
        }
      },
      wanc(){
        if($('.q6').hasClass("active")){
          return false;
        }else{
          this.$http.post(api.password, {
              // phone: this.phone,
              // secretCode: this.code,
              // password: this.$getRsaCode(this.pass1),
              // token: this.sucode
              rpassword: this.$getRsaCode(this.pass1),
              password: this.$getRsaCode(this.pass1),
              token: this.sucode
            },{
              emulateJSON: true
            }).then(response  => {
            console.log(response);
            if(response.body.success==1){
              this.$router.push({ path: 'login'})
            }else{
              $('.me1').text(response.body.data);
            }
          })
        }
      }
    },
    created(){

    },
    mounted(){
      this.jianting();
      $('.z1').scroll(function () {
        if($(this).scrollTop()>1700){
          $('.lo').removeClass('active');
        }
      })
      $('.zhezhao').css({"height":$(window).height()+"px","width":$(window).width()+"px"});
    },
    beforeDestroy() {
      clearInterval(this.timer)
      this.timer = null
    }
  }
</script>

<style scoped>
  input{
    border: none;
    outline: none;
    background-color: rgba(241, 241, 242, 1);
    color: rgb(153,153,153);
    font-size: 14px;
    height: 1.5rem;
    line-height: 1.5rem;
   /* margin-top: 0.15rem;
    margin-left: 0.5rem;*/
    position: absolute;
    top: 50%;
    left: 4.2rem;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .my{
    padding-top: 0.9rem;
    padding-bottom: 4rem;
    background-image: url("../../static/images/re.png");
  }
  .cont{
    width: 17.25rem;
    height: 25.2rem;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 1);
    margin: 0 auto;
    padding-top: 0.7rem;
    display: block;
  }
  .r1{
    height: 1rem;
    line-height: 1rem;
    positiobn:relative;
    text-align:center;
  }
  .r1 img{
    left:1.45rem;
    position:absolute;
  }
  .r1 span{
    color: rgb(51,51,51);
    font-size: 0.8rem;
  }
  .code{
    width:6rem;
  }
  .c2{
    width: 15.75rem;
    height: 1.8rem;
    border-radius: 8px;
    background: rgb(241,241,241);
    margin: 2.1rem auto 0;
    position: relative;
  }
  .c3{
    width: 15.75rem;
    height: 1.8rem;
    border-radius: 8px;
    background: rgb(241,241,241);
    margin: 0.5rem auto 0;
    position: relative;
  }
  .c4{
    color: rgb(51,51,51);
    font-size: 0.7rem;
   /* margin-left: 0.5rem;*/
    position: absolute;
    top: 50%;
    left: .5rem;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .c5{
    width: 15.75rem;
    margin: 0.6rem auto 0;
  }
  .c51{
    width: 0.8rem;
    height: 0.8rem;
    transform: translateY(0.1rem);
  }
  .c52{
    font-size: 0.65rem;
    color: #666;
    margin-left: 0.5rem;
  }
  .c53{
    font-size: 0.65rem;
    color: rgba(196, 77, 65, 1);
    margin-left: 0.5rem;
  }
  .zhezhao{
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
  }
  .zz{
    width: 17.25rem;
    height: 25.2rem;
    padding-top: 0.7rem;
    border-radius: 8px;
    background-color: rgb(255, 255, 255);
    position: absolute;
    top: 0.9rem;
    left: 50%;
    transform: translateX(-50%);
    overflow-y: scroll;
  }
  .lo{
    margin: 0.5rem auto 1rem;
    width: 15.75rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.4rem;
    background-color: rgba(196, 77, 65, 1);
    text-align: center;
    color: #fff;
    font-size: 0.7rem;
    display: block;
    border: none;
    outline:none;
  }
  .lo.active{
    color: #999;
    background-color: #d8d8d8;
  }
  .z1{
    height: 19rem;
    overflow-y: scroll;
  }
  .z2{
    margin-top: 1rem;
  }
  .c41{
    font-size: 0.7rem;
    color: rgb(153,153,153);
    float: right;
    height: 1.8rem;
    line-height: 1.8rem;
    margin-right: 0.5rem;
  }
  .c41.active{
    color: rgb(196,77,65);
  }
  .c6{
    margin: 0.5rem auto 1rem;
    width: 15.75rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.4rem;
    background-color: rgba(196, 77, 65, 1);
    text-align: center;
    color: #fff;
    font-size: 0.7rem;
    display: block;
    border: none;
    outline:none;
  }
  .c6.active{
    color: #999;
    background-color: #d8d8d8;
  }
  .me{
    font-size: 12px;
    color: #c44d41;
    margin: 0.5rem auto 0;
    width: 15.75rem;
    height: 12px;
  }
  .cont1{
    width: 17.25rem;
    height: 25.2rem;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 1);
    margin: 0 auto;
    padding-top: 0.7rem;
    display: none;
  }
  .me1{
    font-size: 12px;
    color: #c44d41;
    margin: 0.5rem auto 0;
    width: 15.75rem;
    height: 12px;
  }
  .q2{
    width: 15.75rem;
    height: 1.8rem;
    border-radius: 8px;
    position: relative;
    background: rgb(241,241,241);
    margin: 2.1rem auto 0;
  }
  .q3{
    width: 15.75rem;
    height: 1.8rem;
    position: relative;
    border-radius: 8px;
    background: rgb(241,241,241);
    margin: 0.5rem auto 0;
  }
  .q4{
    color: rgb(51,51,51);
    line-height: 1.8rem;
    font-size: 0.7rem;
    margin-left: 0.5rem;
  }
  .q6{
    margin: 0.5rem auto 1rem;
    width: 15.75rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.4rem;
    background-color: rgba(196, 77, 65, 1);
    text-align: center;
    color: #fff;
    font-size: 0.7rem;
    display: block;
    border: none;
    outline:none;
  }
  .q6.active{
    color: #999;
    background-color: #d8d8d8;
  }
  .q7{
    margin-top: 2.5rem;
    text-align: center;
  }

  .img_code{
    font-size: 0.7rem;
    color: rgb(196,77,65);
    float: right;
    height: 1.8rem;
    line-height: 1.8rem;
    /* margin-top: 0.15rem;
    margin-right: 0.5rem; */
  }
</style>



// WEBPACK FOOTER //
// src/view/resetPass.vue